angular.module('NaviaqWebApp').directive('activity', [function () {
    'use strict';

    return {
        restrict: 'E',
        replace: true,
        scope: {
            activityData: '='
        },
        templateUrl: 'app/report/directives/activity.html',
        link: function (scope, element, attrs) {
        }
    };
}]);
